/**
 * React Query hook for fetching ICP tests data
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/icpTests';
import type { ICPTestFilters } from '@/types/sensor';
import { useTank } from '@/contexts/TankContext';
import { CACHE_TIMES } from '@/config/cacheTimes';

export function useICPTests(filters?: ICPTestFilters) {
  const { selectedTank } = useTank();
  const tankId = selectedTank?.id;

  return useQuery({
    queryKey: ['icp-tests', tankId, filters],
    queryFn: () => api.getICPTests(tankId!, filters),
    enabled: !!tankId,
    // Keep data fresh
    staleTime: CACHE_TIMES.LIVE,
    // Retry on failure
    retry: 2,
  });
}
